import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const List = ({ title, items, tone, testid }) => (
  <div data-testid={testid}>
    <div className={`text-xs font-semibold uppercase tracking-wider mb-1 ${tone}`}>{title} ({items.length})</div>
    {items.length ? <ul className="text-sm list-disc pl-5 space-y-0.5">{items.map((x) => <li key={x}>{x}</li>)}</ul> : <p className="text-xs text-slate-400">Nothing</p>}
  </div>
);

// Plain gains / losses for one role before its permission edits go live
export function RoleChangeReview({ role, draft, onClose, onApplied }) {
  const [rep, setRep] = useState(null);
  const [busy, setBusy] = useState(true);
  useEffect(() => {
    api.post(`/roles/${role.key}/preview-permissions`, { permissions: draft }).then((r) => setRep(r.data)).catch((e) => { toast.error(errMsg(e)); onClose(); }).finally(() => setBusy(false));
  }, [role.key, draft, onClose]);
  const apply = async () => {
    setBusy(true);
    try { await api.put(`/roles/${role.key}`, { permissions: draft }); toast.success(`${role.name} updated - changes are live`); onApplied(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl w-[95vw] max-h-[90vh] overflow-y-auto" data-testid="role-change-review">
        <DialogHeader><DialogTitle>Review permission changes · {role.name}</DialogTitle></DialogHeader>
        {!rep ? <p className="text-sm text-slate-500">Checking…</p> : (
          <div className="space-y-4">
            <List title="Gains access to" items={rep.gained} tone="text-emerald-700" testid="role-review-gained" />
            <List title="Loses access to" items={rep.lost} tone="text-red-700" testid="role-review-lost" />
            <div className="rounded border border-slate-200 bg-slate-50 px-3 py-2 text-xs" data-testid="role-review-users">
              <b>Affects {rep.users_count} active user(s)</b>{rep.users.length > 0 && `: ${rep.users.join(", ")}`}
            </div>
            <p className="text-xs text-slate-500">Nothing changes until you click Apply. The change is recorded in the audit trail.</p>
          </div>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} data-testid="role-review-back">Back to editing</Button>
          <Button disabled={busy || !rep} onClick={apply} data-testid="role-review-apply">Apply changes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
